export {default as RegistrationWizard} from "./_web/RegistrationWizard";

export {default as reducer }  from './reducers';